import { createSlice } from "@reduxjs/toolkit";

export interface MoMoStatusState {
  payload: "ACTIVE" | "INACTIVE";
}

const slice = createSlice({
  name: "momoPaymentStatus",
  initialState: { payload: "INACTIVE" } as MoMoStatusState,
  reducers: {
    momoPaymentStatus: (state, { payload }: { payload: MoMoStatusState }) => {
      state.payload = payload.payload;
    }
  }
});

export const { momoPaymentStatus } = slice.actions;
export default slice.reducer;
